import styled from 'styled-components';

interface ItemProps {
  readonly overflow?: string;
}

export const FluidContainer = styled.section<ItemProps>`
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  width: auto;
  ${props => {
    return props.overflow === 'true' ? 'overflow-x: auto;' : '';
  }}
  @media (max-width: 1323px) {
    margin: 0 10px;
  }
`;
